import React, { PropTypes } from "react"
import { Fieldset as Group } from "react-redux-form/immutable"
import { Fieldset, Row, Field } from "react-gridforms"

import Input from "components/Input"

const FormHeader = ({ model }) => {
  return (
    <Fieldset legend={" "} disabled>
      <Group model=".header">
        <Row>
          <Field>
            <Input model=".section" label="Section" />
          </Field>
          <Field span="2">
            <Input model=".schedule" label="Schedule" />
          </Field>
          <Field>
            <Input model=".max_slots" label="Max Slots" />
          </Field>
        </Row>
        {model.get("subjects").map((item, k) => {
          const size = model.get("subjects").size
          if (k + 1 > size / 2) {
            return null
          }
          return (
            <Row key={k}>
              <Field span="2">
                <Input model={`.subjects[${k}].code`} label="Subject Code" />
              </Field>
              <Field span="7">
                <Input
                  model={`.subjects[${k}].name`}
                  label="Subject Description"
                />
              </Field>
              <Field span="2">
                <Input
                  model={`.subjects[${size / 2 + k}].code`}
                  label="Curr. Code"
                />
              </Field>
              <Field span="1">
                <Input model={`.subjects[${k}].units`} label="Units" />
              </Field>
            </Row>
          )
        })}
      </Group>
    </Fieldset>
  )
}

FormHeader.propTypes = {
  model: PropTypes.object,
}

export default FormHeader



// WEBPACK FOOTER //
// ./src/containers/Grades/form-header.js